import { styled } from "@mui/material"

export const PageContainer = styled("div")({
  maxWidth: 1200,
  margin: "0 auto",
  paddingLeft: 36,
  paddingRight: 36,
})
